// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3UyZj","buttons":"PendingPaymentAlert_buttons__1c3Ce"};